import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'home-offers-featured-strip.no-offers-available-title': {
    id: 'home-offers-featured-strip.no-offers-available-title',
    defaultMessage: 'No offers available',
    description: 'Title for "No Data View" section for featured offers section (when offers tab enabled)',
  },
});
